/* eslint-disable class-methods-use-this */
import { Categories as PlatformCategories } from 'models/business/Platform';

export default class Performance {
  constructor(data) {
    this.clicks = 0;
    this.impressions = 0;
    this.conversions = 0;
    this.totalConversionValue = 0;
    this.cost = 0;
    this.platform = PlatformCategories.Google;

    this.initialize(data);
  }

  initialize(data = {}) {
    this.clicks = data.clicks ?? this.clicks;
    this.impressions = data.impressions ?? this.impressions;
    this.conversions = data.conversions ?? data.omniPurchase ?? this.conversions;
    this.totalConversionValue = data.totalConversionValue
      ?? data.omniPurchaseConversionValue
      ?? this.totalConversionValue;
    this.cost = data.cost ?? this.cost;
    this.platform = data.platform ?? this.platform;
  }

  get clickThroughRate() {
    return this.impressions !== 0 ? (this.clicks / this.impressions) * 100 : 0;
  }

  get conversionRate() {
    return this.clicks !== 0 ? (this.conversions / this.clicks) * 100 : 0;
  }

  get costPerCustomer() {
    return this.conversions !== 0 ? (this.totalConversionValue / this.conversions) : 0;
  }

  get returnOnAdSpend() {
    return this.cost !== 0 ? this.totalConversionValue / this.cost : 0;
  }
}
